import { jsx as e, jsxs as x } from "react/jsx-runtime";
import f from "@emotion/styled";
import { Box as s, shippoTheme as o, Info as g, colors as n, Error as m, useMediaQuery as u, Typography as b, Button as h, elevations as a } from "@goshippo/components";
const y = f(s)`
  min-width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${o.spacing(1)};
  position: relative;
  box-sizing: border-box;
`, c = {
  info: {
    icon: e(g, { fontSize: "medium" }),
    bgColor: n.accent.foreground.informational
  },
  notice: {
    icon: e(m, { fontSize: "medium" }),
    bgColor: n.text.default
  }
}, v = (l) => {
  const { bannerType: r, message: p, actionLabel: t, actionFn: d } = l, i = u(o.breakpoints.down("sm"));
  return x(y, { sx: {
    backgroundColor: c[r].bgColor,
    flexDirection: i ? "column" : "row",
    px: o.spacing(2),
    py: i ? o.spacing(1) : o.spacing(0.5)
  }, children: [!i && e(s, { sx: {
    display: "flex",
    alignSelf: "flex-start",
    py: o.spacing(1),
    color: n.accent.background.informational
  }, children: c[r].icon }), e(b, { variant: "body", component: "p", color: n.secondaryHover, sx: { py: i ? o.spacing(0) : o.spacing(1) }, children: p }), t && // button style is not yet defined in the theme so we are using inline styles.
  // https://www.figma.com/file/MC7mqNr3TiMkO7Vd63qHPg/shippo-design-system-(2023)?type=design&node-id=83217%3A34146&mode=dev
  e(h, { variant: "text", onClick: d, size: "small", color: "inherit", sx: {
    color: n.white,
    boxShadow: a[0],
    backgroundColor: n.transparent,
    "&:hover": {
      boxShadow: a[1],
      backgroundColor: n.text.default
    },
    "&:focus": {
      outline: `${n.borderFocus} 4px solid`
    }
  }, children: t })] });
};
export {
  v as default
};
//# sourceMappingURL=FullScreenBanner.js.map
